<ng-container *ngIf="isReady() withLoading">
  <div fxLayout="column" fxFill>
    <div fxFlex>
      <agent-panel #agentPanel></agent-panel>
    </div>
    <div fxFlex="grow" fxLayout="column">
      <div *ngIf="isPaused(); else availableBlock" class="unavailable-state-overlay pa-1 mt-2" data-ci="unavailable"
        fxLayout="column" fxLayoutAlign="center center">
        <div *ngIf="connection_status.is_paused">
          <h2>{{ 'public.pause'|translate }}: {{connection_status.pause_reason ? (connection_status.pause_reason.label|translate) : ''}} </h2>
          <button mat-stroked-button color="accent" (click)="openDialogPause()"
            class="mb-1 button-action-call button-connection">
            {{'agent_panel.actions.change_pause_reason'|translate }}
          </button>
          <h1 fxLayoutAlign="center center">
            <mat-icon style="padding-right: 10px">access_time</mat-icon>
            <timer-since [since]="connection_status?.available_since"></timer-since>
          </h1>
          <button data-ci="resume" mat-stroked-button color="accent" (click)="unpause()"
            class="button-action-call button-connection">
            {{'agent_panel.actions.resume'|translate}}
          </button>
        </div>
      </div>

      <ng-template #availableBlock>
        <div class="keypad-conatiner" fxLayout="column" fxLayoutAlign="start center" fxFlex="noshrink">
          <div *ngIf="phoneEngineReady()">
            <jsphone-status></jsphone-status>
          </div>
          <div>
            <keypad tabindex="0" class="keypad" #keypad [hidden]="keypadHidden()" [enabled]="canMakeCall()"></keypad>
          </div>
          <!-- <button *ngIf="isElectron" mat-icon-button (click)="changeVolumn()" class="bt-volume">
              <mat-icon *ngIf="phoneService.audioDevicesOK()">volume_up</mat-icon>
              <mat-icon *ngIf="!phoneService.audioDevicesOK()" color="warn" class="icon-error">volume_off</mat-icon>
          </button> -->
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
